<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-modal.modal-objects
      class="float-right mb-1"
      variant="primary"
      @click="editObects = {}"
    >
      <feather-icon icon="PlusIcon" size="16" />
      {{ $t("general.add") }}
    </b-button>

    <b-table
      :fields="fields"
      :items="GET_OBECTS.results"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(actions)="props">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.modal-objects
          size="sm"
          class="mt-50 mb-50"
          variant="warning"
          @click="editTableRow(props.item)"
        >
          <feather-icon icon="EditIcon" size="15" />
        </b-button>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          size="sm"
          class="ml-1 mt-50 mb-50"
          variant="danger"
          @click="deleteObects(props)"
        >
          <feather-icon icon="TrashIcon" size="15" />
        </b-button>
      </template>
    </b-table>

    <Pagination
      :nobody="nobody"
      :rows="GET_OBECTS.count"
      :params="params"
      @refresh="refresh()"
    />

    <addEditModal :edit-obects="editObects" />
  </div>
</template>

<script>
import { BButton, BTable } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import addEditModal from "./addEditModal.vue";
import areYouSure from "@/mixins/areYouSure";

export default {
  components: {
    BButton,
    BTable,
    Pagination,
    addEditModal,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure],
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      editObects: {},
      nobody: false,
      params: {
        search: "",
        page_size: 10,
        page: 1,
      },
      // ===============  PRIMARY_DATA_SECTION END ===============



      // ===============  OTHERS_SECTION START ===============
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          label: "namee",
          key: "title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      // ===============  OTHERS_SECTION END ===============



    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_OBECTS"]),
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============


  },
  methods: {
    ...mapActions("obectsWarehouse", ["FETCH_OBECTS", "DELETE_OBECTS"]),

    async refresh(){
      await this.FETCH_OBECTS(this.params)
    },

    editTableRow(item){
      this.$route.params.editMode = true
      this.editObects = item
    },


    // ===============  DELETE_SECTION START ===============
    deleteObects(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_OBECTS(props.item.id)
            .then(async () => {
              await this.refresh();
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============




  },
};
</script>
